import { useSelector } from 'react-redux'

export default function usePrecontractFctMeta (precontactId) {
  return useSelector(state => state.status.student_meta.fct_precontracts.find(fct => fct.precontract_id === parseInt(precontactId)))
}
